import { render, staticRenderFns } from "./SkeletonLoader.vue?vue&type=template&id=1ca1418e&scoped=true"
var script = {}
import style0 from "./SkeletonLoader.vue?vue&type=style&index=0&id=1ca1418e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca1418e",
  null
  
)

export default component.exports